import { networkLogos } from 'src/constants'
import { createNetworkLogo } from '../utils/plans'
import { useMemo } from 'react'

export const useFormatFanduelData = (plan, data = null, showDefaultNetworkLogos = true) => {
  // Memoize the formatted plans
  return useMemo(() => {
    // Create a new plans array, updating the standalone plan if needed
    let updatedPlan = plan
    if (data) {
      updatedPlan = {
        ...plan,
        //if package is present, add it to the plan name for tracking
        plan: `${plan.plan} ${data.package ? `${data.package}` : ''}`,
        offerCode: data.offerCode,
        promoImg: data.promoImg,
        //show default network logos is from fanduel data. If it's not present, use the plan data
        ...(showDefaultNetworkLogos &&
          data?.rsn && {
            networkLogos: data.rsn
              .map((network) => {
                const networkLogo = networkLogos[network.toLowerCase().replace(/\s+/g, '_')]
                return networkLogo ? createNetworkLogo(networkLogo, 135, 48) : null
              })
              .filter(Boolean),
          }),
        price: data.price,
        discountedPrice: data.discountedPrice,
        teams: data.teams,
        rsn: data.rsn,
      }
    }

    return updatedPlan
  }, [plan, data])
}
